import { isViewed as isViewedCluster } from '../../../../browser/utils/viewedClusters';
import { IOffer } from '../../repositories/dailyrent/entities/offer/Offer';

// Просмотренность оффера в фиче: серверный флаг ИЛИ локальная отметка из localStorage
export function withViewedState(offer: IOffer): IOffer {
  return { ...offer, isViewed: offer.isViewed || isViewedCluster(offer.cianId) };
}
